import { AuthenticationService } from "./../../../../service/api/auth/auth.service";

import { CompanyManageService } from "./../../../../service/api/jubili/company-manage.service";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
// Import Model
import { CompanyManagelistModel } from "../../../../model/jubili/company-manage/company-list";
import { SortCompanyModel } from "../../../../model/jubili/company-manage/company-sort";
// Import Enum
import { SortType } from "../../../../enum/jubili/company-manage/sort-type";
import { CompanyEditModalComponent } from "../../../shared/jubili-edit-modal/company-edit-modal.component";
import { UpdateAccessCompanyModel } from "../../../../model/jubili/company-manage/update-access-company.model";
import { LocalStorageService } from "angular-2-local-storage";
import { DatetimeModal } from "../../../../model/jubili/common/datetime-modal";
import { JubiliEditFeatureModalComponent } from '../../../shared/jubili-edit-feature-modal/jubili-edit-feature-modal.component';
import { CompanyUpdateFeatureModel } from '../../../../model/jubili/company-manage/company-update-feature-model';
import { JubiliLpmEditModalComponent } from "../../../shared/jubili-lpm-edit-modal/jubili-lpm-edit-modal.component";
import { environment } from "../../../../../environments/environment";

@Component({
    selector: "bo-jub-company-table",
    templateUrl: "./company-table.component.html",
    styleUrls: ["./company-table.component.scss"]
})

export class CompanyTableComponent implements OnInit {

    @Output() sortOutput = new EventEmitter<SortCompanyModel>();
  @Output() refreshData = new EventEmitter();
    private _data = new BehaviorSubject<Array<CompanyManagelistModel>>(new Array<CompanyManagelistModel>());
    @Input()
    set getCompanyDataIndex(value) {
        this._data.next(value);
    }
    get getCompanyDataIndex(): Array<CompanyManagelistModel> {
        return this._data.getValue();
    }

    @ViewChild("RegisterModal") CompanyEditModal: CompanyEditModalComponent;
    @ViewChild("EditFeatureModal") JubiliEditFeatureModal: JubiliEditFeatureModalComponent;
    @ViewChild("lpmModal") lpmModal: JubiliLpmEditModalComponent;

    // using for sort company
    sortData: SortCompanyModel = new SortCompanyModel();
    sortName: boolean = false;
    sortPhone: boolean = false;
    sortCompanyEmail: boolean = false;
    sortCountry: boolean = false;
    sortProvince: boolean = false;
    sortDistrict: boolean = false;
    sortUserEmail: boolean = false;
    sortIsbadge: boolean = false;
    sortSurrkey: boolean = false;
    sortGrade: boolean = false;
    sortHide: boolean = false;
    sortQo: boolean = false;
    sortSo: boolean = false;
    sortTotalSo: boolean = false;
    sortAccess: boolean = false;
    sortExp: boolean = false;
    sortIsQoPhoto: boolean = false;
    sortIsActiveLocationFeature: boolean = false;
    sortActiveDay: boolean = false;
    sortActiveUsers: boolean = false;
    sortInActiveUsers: boolean = false;
    ishide: boolean = true;
    isbadge: boolean = true;
    isQoPhoto: boolean = true;
    imageSrc: string = "";

    constructor(
        public router: Router,
        public companyManageService: CompanyManageService,
        private AuthService: AuthenticationService,
        private localStorageService: LocalStorageService
    ) { }

    ngOnInit(): void {
        this._data
            .subscribe(x => {
                console.log(this._data);
            });
    }

    setdataGradeCompany(grade: string): string {
        switch (grade) {
            case "0": {
                grade = "Active";
                break;
            }
            case "1": {
                grade = "Non-active";
                break;
            }
            case "2": {
                grade = "Hold";
                break;
            }
            case "3": {
                grade = "Terminate";
                break;
            }
            default: {
                grade = "-";
                break;
            }
        }

        return grade;
    }

    setHideCompany(hide: string = ""): string {
        switch (hide) {
            case "0": {
                hide = "Unhide";
                break;
            }
            case "1": {
                hide = "Hide";
                break;
            }
            default: {
                hide = "";
                break;
            }
        }

        return hide;
    }

    // Check box hide company
    autoHideCompany(companySurrKey: number): void {
        // ส่ง 0 ไปเพราะ ค่าเดิมมันเป็น 1 (hide=1,unhide=0)
        console.log(companySurrKey);
        this.sortData.hidecompany = 0;
        this.sortData.companyhideSurrKey = companySurrKey;
        this.sortOutput.emit(this.sortData);
    }

    autoUnHideCompany(companySurrKey: number): void {
        // ส่ง 1 ไปเพราะ ค่าเดิมมันเป็น 0 (hide=1,unhide=0)
        console.log(companySurrKey);
        this.sortData.hidecompany = 1;
        this.sortData.companyhideSurrKey = companySurrKey;
        this.sortOutput.emit(this.sortData);
    }

    // Check box Badge company
    autoBadgeCompany(companySurrKey: number): void {
        // ส่ง 0 ไปเพราะ ค่าเดิมมันเป็น 1 (true=1,false=0)
        console.log(companySurrKey);
        this.sortData.badgecompany = 0;
        this.sortData.companybadgeSurrKey = companySurrKey;
        this.sortOutput.emit(this.sortData);
    }

    autoUnBadgeCompany(companySurrKey: number): void {
        // ส่ง 1 ไปเพราะ ค่าเดิมมันเป็น 0 (true=1,false=0)
        console.log(companySurrKey);
        this.sortData.badgecompany = 1;
        this.sortData.companybadgeSurrKey = companySurrKey;
        this.sortOutput.emit(this.sortData);
    }



    // When click header call function
    sortStatus(event: any, status: boolean): void {
        this.sortName = false;
        this.sortPhone = false;
        this.sortCompanyEmail = false;
        this.sortCountry = false;
        this.sortProvince = false;
        this.sortDistrict = false;
        this.sortUserEmail = false;
        this.sortIsbadge = false;
        this.sortSurrkey = false;
        this.sortGrade = false;
        this.sortHide = false;
        this.sortQo = false;
        this.sortSo = false;
        this.sortTotalSo = false;
        this.sortExp = false;
        this.sortIsQoPhoto = false;
        this.sortIsActiveLocationFeature = false;
        this.sortActiveDay = false;
        this.sortActiveUsers = false;
        this.sortInActiveUsers = false;
        if (status === true) { // sort to DESC
            this.sortName = false;
            this.sortPhone = false;
            this.sortCompanyEmail = false;
            this.sortCountry = false;
            this.sortProvince = false;
            this.sortDistrict = false;
            this.sortUserEmail = false;
            this.sortIsbadge = false;
            this.sortSurrkey = false;
            this.sortGrade = false;
            this.sortHide = false;
            this.sortQo = false;
            this.sortSo = false;
            this.sortTotalSo = false;
            this.sortExp = false;
            this.sortAccess = false;
            this.sortIsQoPhoto = false;
            this.sortIsActiveLocationFeature = false;
            this.sortActiveDay = false;
            this.sortActiveUsers = false;
            this.sortInActiveUsers = false;

            this.sortData.sortCol = event;
            this.sortData.sortType = SortType.DESC;
            this.sortOutput.emit(this.sortData);
        } else {// sort to ASC
            if (event === "companyName") {
                this.sortName = true;
                this.sortData.sortCol = "companyName";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "companyPhone") {
                this.sortPhone = true;
                this.sortData.sortCol = "companyPhone";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "companyEmail") {
                this.sortCompanyEmail = true;
                this.sortData.sortCol = "companyEmail";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "country") {
                this.sortCountry = true;
                this.sortData.sortCol = "country";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "province") {
                this.sortProvince = true;
                this.sortData.sortCol = "province";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "district") {
                this.sortDistrict = true;
                this.sortData.sortCol = "district";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "usercreateemail") {
                this.sortUserEmail = true;
                this.sortData.sortCol = "usercreateemail";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "isbadge") {
                this.sortIsbadge = true;
                this.sortData.sortCol = "isbadge";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "companySurrkey") {
                this.sortSurrkey = true;
                this.sortData.sortCol = "companySurrkey";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "companyGrade") {
                this.sortGrade = true;
                this.sortData.sortCol = "companyGrade";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "companyHide") {
                this.sortHide = true;
                this.sortData.sortCol = "companyHide";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "Quotation") {
                this.sortQo = true;
                this.sortData.sortCol = "Quotation";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
             } else if (event === "Saleorder") {
                this.sortSo = true;
                this.sortData.sortCol = "Saleorder";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "Totalsaleorder") {
                this.sortTotalSo = true;
                this.sortData.sortCol = "Totalsaleorder";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "Expire") {
                this.sortExp = true;
                this.sortData.sortCol = "Expire";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "IsQoPhoto") {
                this.sortIsQoPhoto = true;
                this.sortData.sortCol = "IsQoPhoto";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "IsAccess") {
                this.sortAccess = true;
                this.sortData.sortCol = "IsAccess";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "IsActiveLocationFeature") {
                this.sortIsActiveLocationFeature = true;
                this.sortData.sortCol = "IsActiveLocationFeature";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "activeDay") {
                this.sortActiveDay = true;
                this.sortData.sortCol = "activeDay";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "activeUsers") {
                this.sortActiveUsers = true;
                this.sortData.sortCol = "activeUsers";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "inActiveUsers") {
                this.sortInActiveUsers = true;
                this.sortData.sortCol = "inActiveUsers";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            }
        }
    }

    // check company logo if no have logo must set default logo
  Checkpic(data: CompanyManagelistModel): string {
    if (!data.companyLogo || data.companyLogo.trim() === "") {
      return "../../../../assets/images/defaultAvatar.svg";
    }
    else if (data.isCompanyLogoNewFormat) {
      return environment.jubiliPathS3NewFormat + data.companyLogo;
    }
    else {
      return environment.jubiliPathS3 + data.companyLogo;

    }
  }

    UpdateAccessCompany(companySurrKey: number, status: boolean): void {
      const data = new UpdateAccessCompanyModel();
      this.getCompanyDataIndex.filter(item => item.companySurrKey === companySurrKey)
      .forEach(item => item.isAvaliable = status);
      data.companySurrKey = companySurrKey;
      data.status = status;
      this.companyManageService.updateAccessCompany(data)
      .subscribe(() => {

      },         err => {
        // unauthorized refresh token
        console.log("unauth");
        if (err.status === 401) {
            this.AuthService.refreshSessionToken()
            .subscribe(
                Response => {
                    // Update session
                    this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                    this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                    this.UpdateAccessCompany(companySurrKey, status);
                }
            );
        } else {
            this.router.navigate(["/home"]);
        }
    });
    }

    ConvertDateModelToDate(data: DatetimeModal): Date {
        return data ? new Date(Date.UTC(data.year, data.month - 1, data.day)) : new Date();
    }

    openQoPhotoCompany(companySurrKey: number): void {
        console.log(companySurrKey);
        this.sortData.qoPhotocompany = 1;
        // this.sortData.companyQoPhotoSurrKey = companySurrKey;
        this.sortOutput.emit(this.sortData);
      }

      closeQoPhotoCompany(companySurrKey: number): void {
        console.log(companySurrKey);
        this.sortData.qoPhotocompany = 0;
        // this.sortData.companyQoPhotoSurrKey = companySurrKey;
        this.sortOutput.emit(this.sortData);
      }

      // Check box Active location feature
      openDataWareHouse(companySurrKey: number): void {
          console.log(companySurrKey);
          this.sortData.dataWareHousecompany = 1;
        //   this.sortData.companyDataWareHouse = companySurrKey;
          this.sortOutput.emit(this.sortData);
      }

      closeDataWareHouse(companySurrKey: number): void {
          console.log(companySurrKey);
          this.sortData.dataWareHousecompany = 0;
        //   this.sortData.companyDataWareHouse = companySurrKey;
          this.sortOutput.emit(this.sortData);
      }


    updateFeature(event: CompanyUpdateFeatureModel): void {

        this.sortData.qoPhotocompany = event.isQoPhoto;
        this.sortData.activeLocationFeaturecompany = event.isActiveLocationFeature;
        this.sortData.dataWareHousecompany = event.isDatawarehouse;
        this.sortData.companySurrkey = event.companySurrkey;
        this.sortData.isEditFeature = true;
        this.sortData.isAvailable = event.isAccess;
        this.sortData.isBadge = event.isBadge;
        this.sortData.isHide = event.isHide;
        this.sortData.isActiveLocationOffLimit = event.isActiveLocationOffLimit;
        this.sortData.isGeoMap = event.isGeoMap;
        this.sortData.isAccessWebhook = event.isAccessWebhook;
        this.sortOutput.emit(this.sortData);
    }
    // updateFeature(event: Array<CompanyUpdateFeatureModel>): void {
    //     if(event != []){
    //     event.forEach(s=>{
    //         if(s.topic == "IsQoPhoto"){
    //             if(s.isActive){
    //                 this.openQoPhotoCompany(s.companySurrkey);
    //             } else {
    //                 this.closeQoPhotoCompany(s.companySurrkey);
    //             }
    //         }else if(s.topic =="IsActiveLocationFeature"){
    //             if(s.isActive){
    //                 this.openActiveLocationFeature(s.companySurrkey);
    //             } else {
    //                 this.closeActiveLocationFeature(s.companySurrkey);
    //             }
    //         }else if(s.topic=="IsDatawarehouse"){
    //             if(s.isActive){
    //                 this.openDataWareHouse(s.companySurrkey);
    //             } else {
    //                 this.closeDataWareHouse(s.companySurrkey);
    //             }
    //         }
    //     })
    // }

    openLpmEditModal(val: CompanyManagelistModel) {
        this.lpmModal.open(val.companySurrKey, val.lpmName);
    }
}
